import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData,
  type DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
  type DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse,
  deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete,
} from '../../generated';

export type DeleteImageFromCollectionMutationVariables =
  DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData['path'];

export type DeleteImageFromCollectionMutation =
  DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse;

export const useDeleteImageFromCollectionMutation = <
  TError = DeleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<DeleteImageFromCollectionMutation, TError, DeleteImageFromCollectionMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeleteImageFromCollectionMutation, TError, DeleteImageFromCollectionMutationVariables, TContext>({
    mutationKey: ['DeleteImageFromCollection'],
    mutationFn: async ({ workspace_id, collection_id, image_id }: DeleteImageFromCollectionMutationVariables) => {
      const { data } =
        await deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
          path: { workspace_id, collection_id, image_id },
          throwOnError: true,
        });
      return data;
    },
    ...options,
  });
};

useDeleteImageFromCollectionMutation.fetcher = (
  { workspace_id, collection_id, image_id }: DeleteImageFromCollectionMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } =
      await deleteImageFromCollectionV1WorkspacesWorkspaceIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
        path: { workspace_id, collection_id, image_id },
        throwOnError: true,
      });
    return data;
  };
};
